import { IRegistrationCreditCheck } from "./registrationCreditCheck.types"
import { Dayjs } from "dayjs"
import { safeDayjs } from "@/helpers/dateHelper"

export class RegistrationCreditCheck implements IRegistrationCreditCheck {
  id: number
  status: string | null
  firstName: string
  lastName: string
  accountNumber: string
  billingAccountId: number
  depositDeadline: Dayjs | undefined
  depositPaid: Dayjs | undefined
  dateOfBirth: string
  isAccountActive: boolean
  addressLine1?: string
  postCode?: string
  createdAt: Dayjs | undefined
  amount: number | null
  email: string

  constructor(data: IRegistrationCreditCheck) {
    this.id = data.id
    this.status = data.status
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.accountNumber = data.accountNumber
    this.billingAccountId = data.billingAccountId
    this.depositDeadline = data.depositDeadline
    this.depositPaid = data.depositPaid
    this.dateOfBirth = data.dateOfBirth
    this.isAccountActive = data.isAccountActive
    this.addressLine1 = data.addressLine1
    this.postCode = data.postCode
    this.createdAt = safeDayjs(data.createdAt)
    this.amount = data.amount
    this.email = data.email
  }

  get fullName() {
    return this.firstName + " " + this.lastName
  }
}
